<template>
	<div class="languageselector">
		<vue-simple-drop-down :options="options"
													track-by="id"
													:offset="{ left: -160, top: 56 }"
													v-model="language"
		>
			<!--Button-->
			<template #button>
				<div class="btn btn--circle btn--brown ml-3">
					<div ref="form">
						<slot name="token"></slot>
						<input type="hidden" name="language" :value="language.id">
					</div>
					<span class="languageselector__value">{{ activeLanguageShortcut }}</span>
				</div>
			</template>

			<!--Option-->
			<template #option="{ option }">
				<span class="description">
					{{ option.description }}
				</span>
				<span class="flag">
					<img :src="option.flag" :alt="option.description">
				</span>
			</template>
		</vue-simple-drop-down>
	</div>
</template>

<script>
	import VueSimpleDropDown from '__components__/_forms/inputs/SimpleDropDown/App';
	import { execAsync } from '__application-utils__';
	import { switchLanguage } from './api/switchLanguage';

	export default {
		name: 'vue-language-selector',

		props: {
			options: { type: Array, required: false, default: () => [] },
			value: { type: String }
		},

		data() {
			return {
				language: this.options.find(({ id }) => id === this.value)
			};
		},

		computed: {
			activeLanguageShortcut() {
				return this.language.shortcut;
			}
		},

		watch: {
			language(val, oVal) {
				if (val === oVal) return;
				this.submitForm();
			}
		},

		methods: {
			async submitForm() {
				/** @type {HTMLDivElement} */
				const form = this.$refs.form;
				/** @type {[].<HTMLInputElement>} */
				const inputFields = form.querySelectorAll('input');
				/** @type {FormData} */
				const formData = new FormData();

				inputFields.forEach(field => formData.append(field.name, field.value));

				let pathParts = window.location.pathname.split(/\//);
				pathParts[1] = this.language.id;
				formData.set('language', this.language.id);

				await execAsync(switchLanguage(form.action, formData));

				window.location.href = `${window.location.origin}${pathParts.join('/')}`;
			}
		},

		components: {
			VueSimpleDropDown
		}
	};
</script>
